<template>
    <div>
        <a-modal centered v-if="step == 'custom_with_header'" :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
            <div class="custom-modal-header">
                <label class="custom-modal-header-title fs-20">
                    <span class="color-white">{{ data.title }}</span>
                </label>
            </div>
            <div class="custom-modal-body">
                <label class="custom-modal-body-detail fs-18">
                    {{ data.message }}
                </label>
            </div>
            <!-- footer -->
            <div class="custom-modal-footer text-center">
                <a-button size="large" class="text-center bg-red br-20" @click="cancel()">
                    <span class="fs-18 color-white"> {{ $t('ปิดหน้าต่าง') }}</span>
                </a-button>
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    props: ['visible', 'step', 'data'],
    data() {
        return {
            getting_data: false,
        };
    },
    methods: {
        cancel() {
            this.$emit('on-cancel');
        },
    },
};
</script>
<style scoped>
.custom-modal-header {
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-header-title {
    color: #141322 !important;
    font-weight: 600;
}
.custom-modal-body {
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-body-detail {
    color: #141322 !important;
    font-weight: 300;
}
.custom-modal-footer {
    background: transparent;
    padding: 16px 10px;
}

</style>
